export default "__VITE_ASSET__db65ab29__"